import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuAccessDto } from 'shared/service-proxies/models/menu-access-dto.model';
import { LocalStorage } from '../constants/local-storage.constant';
import { AuthenticationService } from './authentication.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  State = [
    { name: "Select State" },
    { name: "Andaman and Nicobar Islands" },
    { name: "Andhra Pradesh" },
    { name: "Arunachal Pradesh" },
    { name: "Assam" },
    { name: "Bihar" },
    { name: "Chandigarh" },
    { name: "Chhattisgarh" },
    { name: "Dadra and Nagar Haveli" },
    { name: "Daman and Diu" },
    { name: "Delhi" },
    { name: "Goa" },
    { name: "Gujarat" },
    { name: "Haryana" },
    { name: "Himachal Pradesh" },
    { name: "Jammu and Kashmir" },
    { name: "Jharkhand" },
    { name: "Karnataka" },
    { name: "Kerala" },
    { name: "Lakshadweep" },
    { name: "Madhya Pradesh" },
    { name: "Maharashtra" },
    { name: "Manipur" },
    { name: "Meghalaya" },
    { name: "Mizoram" },
    { name: "Nagaland" },
    { name: "Odisha" },
    { name: "Pondicherry" },
    { name: "Punjab" },
    { name: "Rajasthan" },
    { name: "Sikkim" },
    { name: "Tamil Nadu" },
    { name: "Telangana" },
    { name: "Tripura" },
    { name: "Uttar Pradesh" },
    { name: "Uttarakhand" },
    { name: "West Bengal" }
  ]
  
  employeeId: any;
  permanentEmployeeId: any;
  referenceNo: number = 0;
  requestId: any;
  menuAccessWright: MenuAccessDto[];
  onleavedatefordashboard: Date = new Date();
  companyId: number;
  constructor(private _authenticationService: AuthenticationService,
    private _localStorageService: LocalStorageService,
    private _router: Router) { }

  getlocalDatetime(datetime: any): any {
    var date = new Date(datetime.getTime() - (datetime.getTimezoneOffset() * (60 * 1000)));
    date.setUTCSeconds(0);
    return date
  }
  getAllState(): State[] {
    return this.State;
  }

  private _redirect = new BehaviorSubject('');
  redirect = this._redirect.asObservable();

  redirectNotification(redirectTo: string) {
    this._redirect.next(redirectTo)
  }

  private changePassword = new BehaviorSubject(false);
  openChangePassword = this.changePassword.asObservable();

  changePasswordPopup(isOpen: boolean) {
    this.changePassword.next(isOpen);
  }

  private changeusername = new BehaviorSubject(false);
  openChangeUsername = this.changeusername.asObservable();

  changeUsernamePopup(isOpen: boolean) {
    this.changeusername.next(isOpen);
  }

  private detectFilteChange = new BehaviorSubject(false);
  onFilteChange = this.detectFilteChange.asObservable();

  filterChange(isOpen: boolean) {
    this.detectFilteChange.next(isOpen);
  }

  public get selectedAllCompany() {
    let companyID = this._authenticationService.CurrentUserCompanyId()
    if (isNaN(Number(companyID))) {
      return true
    }
    else {
      return false
    }
  }
  UserLogout() {

    this._localStorageService.deleteAllData();
    setTimeout(() => {
      this._router.navigate(['/']);
    }, 1000);

  }

  isClarify() {
    return this._localStorageService.getData('currentUser').isClarify;
  }
  getngxTimerTime(time: any, date: Date): Date {
    let hour = 0
    let minutes = 0
    let timedata = time.split(" ");
    let data = timedata[0].split(":");
    // hour = timedata[1] == "PM" && Number(data[0]) != 12 ? Number(data[0]) + 12 : Number(data[0]);
    hour = (timedata[1] == "AM" && Number(data[0]) == 12) ? 0 : (timedata[1] == "PM" && Number(data[0]) != 12) ? Number(data[0]) + 12 : Number(data[0]);
    minutes = Number(data[1]);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minutes, 0);
  }

  getRemarkMaxlength() {
    return environment.RemarkMaxLength;
  }

  getMonthYear(date) {
    return (date.getFullYear().toString() + ("0" + (date.getMonth() + 1)).slice(-2)).toString();
  }
}

export class detail {
  director: string;
  fatherName: string;
  designation: string;
  date: Date;
}
export interface State {
  name: string;
}
export interface pState {
  name: string;
}